import React from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Accordion-style wrapper used by the landing page "explanation" sections
 * (Three Pillars, How It Works, Guardian Feed, Trust Block, Petverse Preview).
 * Shows only the eyebrow/title + arrow when closed. Opening/closing is fully
 * controlled by the parent so only one section can stay open at a time.
 */
export const CollapsibleSection = ({
  id,
  eyebrow,
  title,
  isOpen,
  onToggle,
  testId,
  children,
}) => {
  return (
    <section id={id} className="py-6 border-b border-slate-800/50 last:border-b-0">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        data-testid={testId}
        className="w-full flex items-center justify-between gap-4 text-left group"
      >
        <div>
          {eyebrow && (
            <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{eyebrow}</p>
          )}
          <h2 className="mt-2 text-2xl sm:text-3xl font-bold text-white group-hover:text-cyan-300 transition-colors">
            {title}
          </h2>
        </div>
        <ChevronDown
          className={`w-6 h-6 flex-shrink-0 text-slate-400 transition-transform duration-300 ${
            isOpen ? 'rotate-180 text-cyan-300' : 'group-hover:text-slate-200'
          }`}
        />
      </button>

      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isOpen ? 'grid-rows-[1fr] opacity-100 mt-6' : 'grid-rows-[0fr] opacity-0 mt-0'
        }`}
      >
        <div className="overflow-hidden">{children}</div>
      </div>
    </section>
  );
};
